import { graphql } from 'react-relay';

export const ConnectFolderQuery = graphql`
    query ConnectFolderQuery($firmMembers: [String]!) {
        viewer {
            ...FolderMenu_viewer
        }
    }
`;
